// extracted by mini-css-extract-plugin
export var numpadContainer = "_sj-1";
export var phoneButton = "_sj-0";